import { SITE } from "@/data/site"

function Footer() {
  return (
    <footer className="w-full border-t border-white/10 bg-black px-8 py-16 md:px-16 lg:px-24">
      <div className="flex w-full flex-col items-start justify-between gap-10 md:flex-row md:items-end">
        <div className="flex items-center gap-4">
          <span className="flex items-center">
            <img src={SITE.logo} alt="MR. EAR" className="h-10 w-auto object-contain mix-blend-screen md:h-12" />
          </span>
          <div>
            <p className="font-sans-ui text-[11px] tracking-[0.32em] text-stone-200">{SITE.brand}</p>
            <p className="font-serif-tc mt-2 text-sm text-stone-500">
              {SITE.productName} · {SITE.artist}
            </p>
          </div>
        </div>
        <p className="font-sans-ui text-[10px] tracking-[0.24em] text-stone-600">{SITE.limitLabel}</p>
      </div>
      <div className="mt-12 border-t border-white/10 pt-8">
        <p className="font-sans-ui text-[10px] leading-6 tracking-[0.2em] text-stone-600">
          耳朵先生 MR. EAR
          <br />
          台北市南港區忠孝東路七段99號產業區三樓
          <br />
          Email：{SITE.email}
          <br />
          Phone：{SITE.phone}
        </p>
      </div>
    </footer>
  )
}

export default Footer
